import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import { ConnectedProps } from "react-redux";
import { useParams } from "react-router-dom";

import ActionButtons from "../../ActionButtons/ActionButtons";
import {
  NavigationPath,
  history,
  offerResponeSingleColumns,
} from "../../../utils";
import {
  ResponseOfferSingleTableType,
  ResponseOfferTableType,
} from "../../../models";
import connector from "./Container";

const ResponseSingle = ({
  actions,
  state,
}: ConnectedProps<typeof connector>) => {
  const { offerResponses } = state;
  const { offerRequestId } = useParams();

  const [singleOfferResponses, setSingleOfferResponses] = useState<
    ResponseOfferSingleTableType[]
  >([]);

  useEffect(() => {
    actions.getOfferResponses();
  }, []);

  useEffect(() => {
    const currentOfferResponses =
      offerResponses
        .find((offer: ResponseOfferTableType) => offer.key === offerRequestId)
        ?.offerResponse.map((response: ResponseOfferSingleTableType) => ({
          ...response,
          key: response.id,
        })) || [];

    setSingleOfferResponses(currentOfferResponses);

    if (currentOfferResponses.length === 0) {
      history.navigate(NavigationPath.OFFER_RESPONSES_ROUTE);
    }
  }, [offerResponses, offerRequestId]);

  const [selectedOffer, setSelectedOffer] = useState<
    ResponseOfferSingleTableType[] | null
  >(null);

  const rowSelection = {
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: ResponseOfferSingleTableType[]
    ) => {
      setSelectedOffer(selectedRows);
    },
  };

  const navigateToDetails = () => {
    if (!selectedOffer) {
      return;
    }
    history.navigate(`/offer-response/${selectedOffer[0].key}`);
  };

  const handleDeleteOffer = () => {
    if (!selectedOffer) {
      return;
    }
    const offerIds = selectedOffer.map((offer) => offer.key);
    actions.deleteSingleOfferResponse(offerIds);
    setSelectedOffer(null);
  };

  const pdfExport = () => {
    if (!offerRequestId) {
      return;
    }
    actions.exportPdf(offerRequestId);
  };

  return (
    <div className="p-4">
      <div className="sm:flex justify-between mb-4">
        <ActionButtons
          navigateToDetails={navigateToDetails}
          handleDelete={handleDeleteOffer}
          selected={selectedOffer}
        />

        <Button
          onClick={pdfExport}
          icon={<FilePdfOutlined />}
          htmlType="button"
          className="bg-estimate-success border-estimate-success text-white px-2 text-center rounded-sm mr-4 mt-3 sm:mt-0"
        >
          IZVEZI U PDF
        </Button>
      </div>
      <Table
        columns={offerResponeSingleColumns}
        dataSource={singleOfferResponses}
        rowSelection={{
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default ResponseSingle;
